<template>
	<div id="app">
		<nav-bar
			@menu-button-click="toggleSideBar"
			@change-max-width="updateSideBarMaxWidth"
			:showBackButton="showBackButton"
			@back-button-click="goBack"
		/>
		<side-bar
			:hidden="sideBarHidden || noPermission"
			:max-width="sideBarMaxWidth"
			@link="sideBarLinkClicked"
			:links="parsedLinks"
			@resize="sideBarResized"
		/>
		<router-view/>
		<vue-snotify></vue-snotify>
		<div id="app-bottom-padding"></div>
	</div>
</template>

<script>
	import { mapMutations } from "vuex";

	import "@/assets/css/mmi.css";
	import "@/assets/css/style.css";
	import "@/assets/scss/index.scss";

	import NavBar from "@/components/NavBar.vue";
	import SideBar from "@/components/SideBar.vue";

	import { copy } from "./helpers/common";
	import { AuthService } from "./services/auth";

	let itensHistorico = 0;

	const isMobile = () => window.innerWidth <= 790;

	export default {
		name: "App",
		components: {
			NavBar,
			SideBar
		},

		data () {
			return {
				sideBarWidth: 0,
				sideBarHidden: true,
				sideBarMaxWidth: 0,
				initialized: false,
				links: [
					{
						to: { name: "home" },
						name: "Dashboard",
						icon: "dashboard",
						showPerms: ["DASHBOARD_INJETORAS"]
					},
					{
						to: { name: "sinoptico" },
						name: "Sinóptico Injetora",
						icon: "bar-chart-2",
						showPerms: ["DASHBOARD_INJETORA_SINOPTICO"]
					},
					{
						to: { name: "relatorioTempoCiclo" },
						name: "Relatório de Tempo de Ciclo e Dosagem",
						icon: "Clock",
						showPerms: ["RLT_TEMPO_CICLO_DOSAGEM"]
					},
					{
						to: { name: "perfilUsuario" },
						name: "Perfil do Usuário",
						icon: "user"
					},
					{
						name: "Gerenciamento",
						icon: "sliders",
						children: [
							{
								to: { name: "ordensProducao" },
								name: "Ordem de Produção",
								icon: "Calendar",
								showPerms: ["GER_S_ORDENS_PRODUCAO"]
							},
							{
								to: { name: "maquinas" },
								name: "Injetoras",
								icon: "cpu",
								showPerms: ["GER_S_MAQUINAS"]
							},
							{
								to: { name: "gruposUsuarios" },
								name: "Grupos de Usuários",
								icon: "users",
								showPerms: ["GER_S_GRUPO_USUARIO"]
							},
							{
								to: { name: "usuarios" },
								name: "Usuários",
								icon: "UserPlus",
								showPerms: ["GER_S_USUARIOS"]
							}
						]
					}
				],
				parsedLinks: [],
				authService: new AuthService()
			};
		},

		computed: {
			showBackButton () {
				const routes = ["home"];
				return !routes.includes(this.$route.name);
			},

			noPermission () {
				return [].some((el) => el === this.$route.name);
			}
		},

		watch: {
			noPermission () {
				this.sideBarHidden = this.noPermission;
				this.updateSideBarWidth(
					this.sideBarHidden || isMobile() ? 0 : this.sideBarWidth
				);
			}
		},

		methods: {
			goBack () {
				if (itensHistorico > 1)
					return this.$router.back();

				let found = false;
				for (let i = this.$route.matched.length - 1; i >= 0; i--) {
					const match = this.$route.matched[i];
					if (match.parent && match.parent.path + "/" !== match.path) {
						itensHistorico--;
						this.$router.push(match.parent.path);
						found = true;
						break;
					}
				}

				if (!found)
					this.$router.push({ name: "home" });
			},

			toggleSideBar () {
				if (this.noPermission) return;

				this.sideBarHidden = !this.sideBarHidden;
				this.updateSideBarWidth(
					this.sideBarHidden || isMobile() ? 0 : this.sideBarWidth
				);
			},

			sideBarResized (w) {
				this.sideBarWidth = w;
				this.updateSideBarWidth(
					this.sideBarHidden || isMobile() || this.noPermission ? 0 : w
				);
			},

			updateSideBarMaxWidth (w) {
				this.sideBarMaxWidth = w;
				if (!this.initialized) {
					// Detecta celular e encolhe a barra
					this.sideBarHidden = w < 100;
					this.initialized = true;
					this.sideBarWidth = 72;
					this.updateSideBarWidth(
						(this.sideBarHidden || isMobile() || this.noPermission) ? 0 : this.sideBarWidth
					);
				}
			},

			sideBarLinkClicked () {
				if (isMobile())
					this.sideBarHidden = !this.sideBarHidden;
			},

			_updateLinks (links) {
				for (const link of links) {
					if (link.children)
						link.children = this._updateLinks(link.children);
				}

				return links.filter(
					ln => !ln.showPerms || !ln.children || ln.children.length > 0
				);
			},

			updateLinks () {
				const links = copy(this.links);
				this.parsedLinks = this._updateLinks(links);
			},

			...mapMutations(["updateSideBarWidth"])
		},

		created () {
			this.updateLinks();

			this.$router.afterEach((to, from) => {
				if (from.name === null || to.name === "home")
					itensHistorico = 0;
				else
					itensHistorico++;
			});

			const usuarioLogado = this.authService.getModuleStorage();
			this.$store.commit("initUsuarioLogado", usuarioLogado);
		},

		provide () {
			return { parentValidator: this.$parent.$validator };
		}
	};
</script>

<style scoped>
	#app-bottom-padding {
		height: 80px;
	}

	@media (max-width: 790px) {
		#app-bottom-padding {
			max-height: 0px;
		}
	}
</style>

<style>
	.text-ellipsis {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow-x: hidden;
	}

	.container {
		max-width: 98%;
	}
</style>
